import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';

var _excluded = ["icon", "label", "className"];
var IconButtonWithLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var Icon = _ref.icon,
    label = _ref.label,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    className: classNames(className, styles.iconButtonWithLabel),
    type: "button",
    ref: ref
  }), /*#__PURE__*/React__default.createElement(Icon, {
    size: "medium",
    className: styles.iconButtonWithLabelIcon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.iconButtonWithLabelLabel
  }, label));
});

export { IconButtonWithLabel as default };
